import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { toast } from "react-hot-toast";

import authService from "../../services/authService";

const ConnectGoogleAccount = () => {
  const { user } = useContext(AuthContext);

  const handleConnectClicked = async (e) => {
    e.preventDefault();

    const redirectRoutePrefix = user?.role === 'admin' ? 'admin' : 'l';

    try {
      const { data: { url } } = await authService.getGoogleAuthUrl({
        redirectUri: `${process.env.REACT_APP_APP_URL}/${redirectRoutePrefix}/profile`
      });

      window.location.href = url;
    } catch (error) {
      console.log(error);
      toast.error('Something went wrong. Please try again');
    }
  };

  return (
    <div className="min-h-[300px] flex flex-col gap-2 items-center justify-center">
      {user?.googleEmail ? (
        <h1>Already connected</h1>
      ) : (
        <>
          <h1>Connect your Google Account</h1>

          <p>Once connected, you'll be able to login via Google.</p>

          <button
            className="ase-button-primary mt-2"
            onClick={handleConnectClicked}
          >
            Connect
          </button>
        </>
      )}
    </div >
  );
};

export default ConnectGoogleAccount;
